export default __webpack_public_path__ + "static/media/image.af5d107e.svg";